import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const autoInsertSlashes = (digits: string): string => {
  const limited = digits.slice(0, 8);
  if (limited.length > 4)
    return `${limited.slice(0, 2)}/${limited.slice(2, 4)}/${limited.slice(4)}`;
  if (limited.length > 2) return `${limited.slice(0, 2)}/${limited.slice(2)}`;
  return limited;
};

const formatWithUserSlashes = (segments: string[]): string => {
  const month = (segments[0] ?? '').slice(0, 2);
  const dayDigits = segments[1] ?? '';
  const yearDigits = segments[2] ?? '';

  if (segments.length === 2) {
    const dayOverflow = dayDigits.slice(2);
    if (dayOverflow) {
      return `${month}/${dayDigits.slice(0, 2)}/${(dayOverflow + yearDigits).slice(0, 4)}`;
    }
    return `${month}/${dayDigits}`;
  }

  return `${month}/${dayDigits.slice(0, 2)}/${yearDigits.slice(0, 4)}`;
};

const DATE_PARSE_FORMATS = ['M/D/YYYY', 'MM/DD/YYYY', 'M/DD/YYYY', 'MM/D/YYYY'];

export const formatDateForDisplay = (input: string): string => {
  if (!input) return '';
  const segments = input.split('/');
  const digitsOnly = segments.map(s => s.replace(/\D/g, ''));

  if (segments.length === 1) return autoInsertSlashes(digitsOnly[0]);
  return formatWithUserSlashes(digitsOnly);
};

export const parseDate = (text: string) => {
  for (const fmt of DATE_PARSE_FORMATS) {
    const d = dayjs(text, fmt, true);
    if (d.isValid()) return d;
  }
  return dayjs(null);
};

export const isDateInRange = (d: dayjs.Dayjs) => d.year() >= 1900 && d.year() <= 2100;
